import React from "react";
import {
  Box,
  Typography,
  Modal,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FlavorInfoModal = ({ open, onClose, flavors }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 2,
          width: "85%",
          maxWidth: 600,
          maxHeight: "80vh",
          overflowY: "auto",
        }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
            color: "grey.600",
          }}>
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ mb: 2 }}>
          Flavor Details
        </Typography>

        {/* Scrollable Table Container */}
        <Box sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Flavor</strong>
                </TableCell>
                <TableCell>
                  <strong>Inside Icing</strong>
                </TableCell>
                <TableCell>
                  <strong>Outside Icing</strong>
                </TableCell>
                <TableCell>
                  <strong>Price</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {flavors.map((flavor) => (
                <TableRow key={flavor._id}>
                  <TableCell>{flavor.displayName}</TableCell>
                  <TableCell>{flavor.icing?.name || "-"}</TableCell>
                  <TableCell>buttercream</TableCell>
                  <TableCell>
                    {flavor.price > 0
                      ? `$${flavor.price.toFixed(2)}`
                      : "included"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Modal>
  );
};

export default FlavorInfoModal;
